<div class="image-rotation-btn" (click)="rotate()">
  <img [class.imageRotation__counterclockwise]="!ppClockwise" [src]="EIconPath.GALLERY_ROTATE" />
</div>
